import _ from 'lodash';

const MAX_INITIALS = 2;

// Up-to-two initials from a person's display name. "Ilya Beyrak" -> "IB",
// "Sarah" -> "S". Returns null when there is no usable name so the avatar can
// fall back to a neutral system glyph rather than rendering an empty circle.
export const resolveInitials = name => {
  if (_.isNil(name) || name.trim() === '') {
    return null;
  }

  const words = name
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0);

  if (_.isEmpty(words)) {
    return null;
  }

  return words
    .slice(0, MAX_INITIALS)
    .map(word => word[0].toUpperCase())
    .join('');
};
